import api from '../api';

/** Debe coincidir con `TiendaProductosPagination` en el backend. */
export const TIENDA_PRODUCTOS_PAGE_SIZE = 16;

function buildProductosQuery(params) {
  const qs = new URLSearchParams();
  const page = params.page ?? 1;
  if (page > 1) qs.set('page', String(page));
  if (params.marca) qs.set('marca', params.marca);
  if (params.categoria) qs.set('categoria', params.categoria);
  if (params.search) qs.set('search', params.search.trim());
  if (params.ordering) qs.set('ordering', params.ordering);
  const s = qs.toString();
  return s ? `?${s}` : '';
}

/**
 * Una página del listado público de productos (`count`, `next`, `previous`, `results`).
 */
export async function getProductsPage(params = {}) {
  return api.get(`/tienda/productos/${buildProductosQuery(params)}`);
}

export async function getProductById(id) {
  return api.get(`/tienda/productos/${id}/`);
}
